export default __webpack_public_path__ + "static/media/question.b6730d66.png";